import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../pages/Home';
import QuickEstimate from '../pages/QuickEstimate';
import ComingSoon from '../pages/ComingSoon';
import Login from '../pages/auth/Login';
import Register from '../pages/auth/Register';
import ForgotPassword from '../pages/auth/ForgotPassword';
import Dashboard from '../pages/dashboard/Dashboard';
import Profile from '../pages/profile/Profile';
import AdminDashboard from '../pages/admin/AdminDashboard';
import DetailedEstimate from '../components/estimation/detailed/DetailedEstimate';
import ViewEstimate from '../pages/estimates/ViewEstimate';
import EditEstimate from '../pages/estimates/EditEstimate';
import PurchaseCredits from '../pages/credits/PurchaseCredits';
import PaymentConfirmation from '../pages/credits/PaymentConfirmation';
import Contact from '../pages/Contact';
import AuthGuard from '../components/auth/AuthGuard';
import AdminGuard from '../components/admin/AdminGuard';
import LegalNotice from '../pages/LegalNotice';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<Home />} />
      <Route path="/quick-estimate" element={<QuickEstimate />} />
      <Route path="/coming-soon" element={<ComingSoon />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/mentions-legales" element={<LegalNotice />} />
      
      {/* Protected routes */}
      <Route path="/profile" element={<AuthGuard><Profile /></AuthGuard>} />
      <Route path="/dashboard" element={<AuthGuard><Dashboard /></AuthGuard>} />
      <Route path="/estimation/nouvelle" element={<AuthGuard><DetailedEstimate /></AuthGuard>} />
      <Route path="/estimation/:id/view" element={<AuthGuard><ViewEstimate /></AuthGuard>} />
      <Route path="/estimation/:id/edit" element={<AuthGuard><EditEstimate /></AuthGuard>} />
      <Route path="/credits/purchase" element={<AuthGuard><PurchaseCredits /></AuthGuard>} />
      <Route path="/credits/confirmation" element={<AuthGuard><PaymentConfirmation /></AuthGuard>} />
      
      {/* Admin routes */}
      <Route path="/admin" element={<AdminGuard><AdminDashboard /></AdminGuard>} />
    </Routes>
  );
};

export default AppRoutes;